import React from 'react'
import { FieldProps } from '../../../../../../../@types/types'
import { ParkingSpaceTypeOption } from '../../../../../../../@types/dropdown-types'
import { OtherFacilitiesScreenValidationResult } from '../../../../../../../@types/validation-types'
import DropdownSelect from '../../../../../../common/inputs/dropdownSelect/DropdownSelect'
import { useTranslation } from 'react-i18next'

const WebViewParkingSpaceType: React.FC<FieldProps<OtherFacilitiesScreenValidationResult>> = ({
  insertionData,
  screenName,
  wrapperClassName = 'grid-item one-whole',
  onChange,
}) => {
  const { t } = useTranslation()

  return (
    <div className={wrapperClassName}>
      <DropdownSelect
        id='mobile-parking-space-type'
        name='parkingSpaceType'
        label={t('wizard.screen.otherFacilities.webViewParkingSpace.type.label')}
        value={insertionData.parkingSpaceType}
        noInformation={ParkingSpaceTypeOption.NONE}
        options={{
          translationKeyGroup: 'wizard.screen.otherFacilities.parkingSpaceTypes',
          options: Object.keys(ParkingSpaceTypeOption),
        }}
        allowEmpty={true}
        errors={[]}
        onChange={(selectedOption) =>
          onChange({ screen: screenName, property: 'parkingSpaceType' }, selectedOption.value)
        }
      />
    </div>
  )
}

export default WebViewParkingSpaceType
